import {
  SanityPrintAreaType,
  SanityPrintSlotSettings,
} from '@data/sanity/queries/types/print'
import { getProductGalleryWithPrintAreas } from './image'

/**
 * Gets print preview image with print areas.
 */
export const getPrintPreviewImageWithAreas = (
  printSlot: SanityPrintSlotSettings,
) => {
  // Get print preview data from print slot
  const previewProductVariant = printSlot.previewProductVariant
  const product = previewProductVariant?.product
  const printPermissions =
    previewProductVariant?.printPermissionSettings?.printPermissions

  if (!previewProductVariant || !product) {
    return
  }

  // Get image with areas
  const productGalleryWithPrintAreas = getProductGalleryWithPrintAreas(
    product.galleryPhotos,
    product.printConfiguration,
  )
  const gallery = productGalleryWithPrintAreas.find((gallery) => {
    const option = previewProductVariant.options
      .map((option) => `${option.name}:${option.value}`)
      .find((option) => option === gallery.forOption)

    return gallery.forOption === option
  })
  let imageWithAreas = gallery?.imagesWithAreas?.find((imageWithAreas) => {
    return imageWithAreas.slotType === printSlot.type
  })

  if (!imageWithAreas) {
    return
  }

  // Filter areas using print permissions
  const printSlotPermissions = printPermissions?.find(
    (printSlotPermissions) => {
      return printSlotPermissions.slot.type === printSlot.type
    },
  )
  const filteredAreas = imageWithAreas.areas?.filter((area) => {
    if (!printSlotPermissions) {
      return true
    }

    switch (area.type) {
      case SanityPrintAreaType.LOGO: {
        return printSlotPermissions.logo
      }

      case SanityPrintAreaType.IMAGE: {
        return printSlotPermissions.image
      }

      case SanityPrintAreaType.TEXT: {
        return printSlotPermissions.text
      }
    }
  })

  imageWithAreas = {
    ...imageWithAreas,
    areas: filteredAreas,
  }

  return imageWithAreas
}
